/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-07-02 13:56:48
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-07-17 18:39:22
 * @FilePath: \ysz_web_international\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as axios from 'axios'
import Encode from './encode'
import { Message } from 'element-ui'
import { Toast } from 'vant'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api的base_url
  timeout: 60000, // request timeout
  headers: {
    'Content-Type': 'application/json'
  },
  // H5 鉴权走 header.token，不依赖 cookie。
  // 服务端 CORS 为 Allow-Origin: * + Allow-Credentials: true 时，
  // withCredentials:true 会被浏览器直接拦截成 Network Error（安卓常见）。
  withCredentials: false,
  // 响应的数据格式 json / blob /document /arraybuffer / text / stream
  responseType: 'json',
})
// request interceptor
service.interceptors.request.use(config => {
  if (localStorage.getItem('ysz_web_international_token')) {
    config.headers.token = localStorage.getItem('ysz_web_international_token')
  }
  config.headers.guid = localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')).guid:window.uuid
  config.headers.uid = localStorage.getItem('userInfo')?JSON.parse(localStorage.getItem('userInfo')).uid:-1
  config.headers.platform = 'overseasH5'
  const fullUrl = `${config.baseURL || ''}${config.url || ''}`
  console.log(`%c 请求：${fullUrl}`, 'color: blue;font-size: 16px', config.data)
  if (config.method === 'post') {
    if (config.type) {
      config.headers['Content-Type'] = config.type
    } else {
      config.data = Encode.encodeFunc(config.data)
    }
  }
  return config
}, error => {
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    var secretData = JSON.parse(Encode.decodeFuc(response.data.data))
    console.log(
      `%c 响应：${response.config.url
      }`,
      'color: green;font-size:16px;',
      secretData
  )
    if (secretData.code === 401) {
      localStorage.removeItem('ysz_web_international_token')
      Message.error('token验证失效！')
      window.location.href =  window.location.href.split('#')[0] +'#/login_register';
      return
    }
    return secretData
  },
  error => {
    const fullUrl = error && error.config
      ? `${error.config.baseURL || ''}${error.config.url || ''}`
      : ''
    console.error('请求失败', {
      message: error && error.message,
      code: error && error.code,
      url: fullUrl,
      response: error && error.response,
    })
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求'
          break
        case 401:
          error.message = '未授权，请重新登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = '请求错误,未找到该资源'
          break
        case 405:
          error.message = '请求方法未允许'
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器端出错'
          break
        case 501:
          error.message = '网络未实现'
          break
        case 502:
          error.message = '网络错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网络超时'
          break
        case 505:
          error.message = 'http版本不支持该请求'
          break
        default:
          error.message = `连接错误${error.response.status}`
      }
      Toast(error.message)
    } else {
      const detail = (error && error.message) || 'Network Error'
      error.message = '连接到服务器失败'
      Toast(`${error.message}\n${detail}\n${fullUrl}`)
    }
    return Promise.reject(error)
  })

export default {
  post (url, params, type) {
    console.log(url)
    return service({
      method: 'post',
      url,
      data: params?params:{},
      type
    })
  },
  get (url, data) {
    return service({
      method: 'get',
      url,
      params: data
    })
  }
}
